import * as React from "react";
import { FocusForm } from "./FocusForm";
import { ErrorList } from "../errors/ErrorList";
import _ from "lodash";
import "./focusForm.scss";
import { ItemStatus } from "@focus/interfaces/lib/common/itemFetchStatus";
import { validation } from "./validation";
import { handleErrorClick } from "./utils";
export const FocusFormValidator = ({ schema, uiSchema, formData, readOnly, needsDefaults, hideErrorList, onChange, onErrorsChange, }) => {
    const [focusErrors, setFocusErrors] = React.useState({});
    const handleError = (errors) => {
        if (errors === null) {
            if (onErrorsChange !== undefined) {
                onErrorsChange(ItemStatus.READY);
            }
            setFocusErrors({});
        }
        else {
            if (onErrorsChange !== undefined) {
                onErrorsChange(ItemStatus.ERROR);
            }
            setFocusErrors(errors);
        }
    };
    const debouncedValidation = React.useCallback(_.debounce(validation, 300), []);
    React.useEffect(() => {
        if (onErrorsChange !== undefined) {
            onErrorsChange(ItemStatus.PENDING);
        }
        debouncedValidation(schema, formData, handleError);
    }, [formData]);
    React.useEffect(() => {
        if (needsDefaults) {
            const { newFormData, modified } = applyDefaults(formData, schema, uiSchema);
            if (modified) {
                handleChange(newFormData, undefined);
            }
        }
    }, [needsDefaults, formData]);
    const handleChange = (newFormData, change) => {
        if (onErrorsChange !== undefined) {
            onErrorsChange(ItemStatus.PENDING);
        }
        onChange(newFormData, change);
    };
    return (React.createElement("div", null,
        Object.keys(focusErrors).length === 0 || hideErrorList ? null : (React.createElement(ErrorList, { uiSchema: uiSchema, errorSet: focusErrors, onErrorClick: handleErrorClick })),
        React.createElement(FocusForm, { schema: schema, uiSchema: uiSchema, formData: formData, readOnly: readOnly, errors: focusErrors, onChange: handleChange })));
};
const defaultFromType = (type) => {
    switch (type) {
        case "string":
            return "";
        case "number":
        case "integer":
            return 0;
        case "boolean":
            return false;
        case "array":
            return [];
        case "object":
            return {};
        default:
            return undefined;
    }
};
export const applyDefaults = (formData, schema, uiSchema) => {
    let newFormData = _.cloneDeep(formData);
    return _applyDefaults(newFormData, schema, uiSchema);
};
export const _applyDefaults = (newFormData, schema, uiSchema) => {
    const order = uiSchema["ui:order"];
    let modified = false;
    for (let i = 0; i < order.length; i++) {
        const key = order[i];
        if (uiSchema[key]["ui:field"] === "separator" ||
            uiSchema[key]["ui:field"] === "tabfield") {
            const subResult = _applyDefaults(newFormData[key], schema.properties[key], uiSchema[key]);
            modified = modified || subResult.modified;
            newFormData[key] = subResult.newFormData;
        }
        else if (uiSchema[key]["ui:field"] === "listfield" && newFormData[key]) {
            for (let j = 0; j < newFormData[key].length; j++) {
                const subResult = _applyDefaults(newFormData[key][j], schema.properties[key].items, uiSchema[key]);
                modified = modified || subResult.modified;
                newFormData[key][j] = subResult.newFormData;
            }
        }
        else if (uiSchema[key]["ui:field"] === "menufield" &&
            !schema.properties[key].enum.find((option) => option === newFormData[key])) {
            if (!uiSchema[key].hasOwnProperty("ui:options")) {
                newFormData[key] =
                    schema.properties[key].default || schema.properties[key].enum[0];
                modified = true;
            }
        }
        else if (uiSchema[key]["ui:field"] === "epochselfield" &&
            (newFormData[key] === null || newFormData[key] === undefined)) {
            newFormData[key] = schema.properties[key].default || DEFAULT_DATE;
            modified = true;
        }
        else if (uiSchema[key]["ui:field"] === "intervalfield" &&
            (newFormData[key] === null ||
                newFormData[key] === undefined ||
                newFormData[key].start === null ||
                newFormData[key].end === null)) {
            newFormData[key] = schema.properties[key].default || DEFAULT_INTERVAL;
            modified = true;
        }
        else if (uiSchema[key]["ui:field"] === "arrayfield" &&
            (newFormData[key] === null || newFormData[key] === undefined)) {
            const defaultArray = Array(schema.properties[key].legends.length).fill(0.0);
            newFormData[key] =
                schema.properties[key].default || defaultArray;
            modified = true;
        }
        else if (uiSchema[key]["ui:field"] === "matrixfield" &&
            (newFormData[key] === null || newFormData[key] === undefined)) {
            const defaultMatrix = Array(schema.properties[key].minItems).fill(Array(schema.properties[key].items.minItems).fill(0.0));
            newFormData[key] =
                schema.properties[key].default || defaultMatrix;
            modified = true;
        }
        else if (newFormData[key] === undefined ||
            newFormData[key] === null ||
            (typeof newFormData[key] === "object" &&
                Object.keys(newFormData[key]).length === 0)) {
            const potentialDefault = schema.properties[key].default !== undefined
                ? schema.properties[key].default
                : schema.properties[key].minimum !== undefined
                    ? schema.properties[key].minimum
                    : schema.properties[key].maximum !== undefined
                        ? schema.properties[key].maximum
                        : defaultFromType(schema.properties[key].type);
            if (potentialDefault !== undefined) {
                newFormData[key] = potentialDefault;
                modified = true;
            }
        }
    }
    return { newFormData, modified };
};
const DEFAULT_DATE = { dateTime: "2000/01/01-00:00:00.000", modifier: 0 };
const DEFAULT_INTERVAL = {
    start: DEFAULT_DATE,
    end: DEFAULT_DATE,
};
//# sourceMappingURL=FocusFormValidator.js.map